import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/liquid_cooling_center.png'


const _withScopeId = n => (_pushScopeId("data-v-5b428138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "statisticView" }
const _hoisted_2 = { class: "head_title" }
const _hoisted_3 = { class: "key" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "static_count" }
const _hoisted_8 = { class: "count" }
const _hoisted_9 = { class: "unit" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "describe" }

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { onMounted, inject, ref, computed, watch, nextTick } from "vue";
import provide_key from "@/constant/provide_key";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsView',
  setup(__props) {

gsap.registerPlugin(ScrollTrigger);
const shrink: boolean | undefined = inject(provide_key.SHRINK);
const { t } = useI18n();
const staticData = computed(() => [
  {
    count: 300,
    unit: "%",
    title: t("home.STATIC_TITLE_1"),
    describe: t("home.STATIC_DESCRIBE_1"),
    backgroundImage: require("@/assets/increase.png"),
  },
  {
    count: "1.1",
    unit: "",
    title: t("home.STATIC_TITLE_2"),
    describe: t("home.STATIC_DESCRIBE_2"),
    backgroundImage: require("@/assets/power.png"),
  },
  {
    count: 75,
    unit: "%",
    title: t("home.STATIC_TITLE_3"),
    describe: t("home.STATIC_DESCRIBE_3"),
    backgroundImage: require("@/assets/space.png"),
  },
  {
    count: 80,
    unit: "%",
    title: t("home.STATIC_TITLE_4"),
    describe: t("home.STATIC_DESCRIBE_4"),
    backgroundImage: require("@/assets/noise.png"),
  },
]);

onMounted(() => {
  const t1 = gsap.timeline({
    scrollTrigger: {
      trigger: ".static_center",
      start: "top 80%",
      end: "top 50%",
      scrub: 0.001,
    },
  });

  const updateAnimation = () => {
    const unShrinkAnimation = () => {
      t1.to("#move_card0", { x: "-100%", y: "-100%", opacity: 1 }, 0)
        .to("#move_card1", { x: "100%", y: "-100%", opacity: 1 }, 0)
        .to("#move_card2", { x: "-100%", y: "100%", opacity: 1 }, 0)
        .to("#move_card3", { x: "100%", y: "100%", opacity: 1 }, 0);
    };
    const shrinkAnimation = () => {
      t1.to("#move_card0", { y: "100%", opacity: 1 }, 0)
        .to("#move_card1", { y: "200%", opacity: 1 }, 0)
        .to("#move_card2", { y: "300%", opacity: 1 }, 0)
        .to("#move_card3", { y: "400%", opacity: 1 }, 0);
    };
    shrink.value ? shrinkAnimation() : unShrinkAnimation();
  };

  updateAnimation(); // 初始化动画

  watch(
    () => staticData.value,
    () => {
      nextTick(() => {
        t1.restart();
        setTimeout(() => t1.pause(), 500);
        updateAnimation(); // 在数据变化时调用
      });
    }
  );
});

return (_ctx: any,_cache: any) => {
  const _directive_translateIn = _resolveDirective("translateIn")!
  const _directive_countUp = _resolveDirective("countUp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t("home.HOME_QUESTION")), 1)
      ])), [
        [_directive_translateIn]
      ])
    ]),
    _createElementVNode("div", {
      class: "static_content",
      style: _normalizeStyle({
        'grid-template-columns': _unref(shrink) ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)',
        'grid-template-rows': _unref(shrink) ? 'repeat(5, 1fr)' : 'repeat(3, 1fr)',
      })
    }, [
      _createElementVNode("div", {
        class: "static_center",
        style: _normalizeStyle({
          gridRow: _unref(shrink) ? '1' : '2/3',
          width: _unref(shrink) ? '100%' : '80%',
        })
      }, _hoisted_5, 4),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staticData.value, (data, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "static_card",
          id: 'move_card' + index,
          key: data.title,
          style: _normalizeStyle({
          gridRow: _unref(shrink) ? '1' : '2/3',
          width: _unref(shrink) ? '100%' : '80%',
          position: 'relative',
          overflow: 'hidden',
        })
        }, [
          _createElementVNode("div", {
            class: "static_card_background",
            style: _normalizeStyle({ backgroundImage: 'url(' + data.backgroundImage + ')' })
          }, null, 4),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
              [_directive_countUp, data.count]
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(data.unit), 1)
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(data.title), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(data.describe), 1)
        ], 12, _hoisted_6))
      }), 128))
    ], 4)
  ]))
}
}

})